// import { useState, useEffect } from 'react';

const Password = () => {

	return (
		<div> This is Home</div>
	)
}
export default Password;